import { Dropdown, Menu, Row } from "antd";

const SettlementDropdown = ({
	targetYear,
	setTargetYear,
	targetMonth,
	setTargetMonth,
}) => {
	const yearItems = (
		<Menu>
			{["2022", "2023", "2024"].map((item, idx) => (
				<Menu.Item
					key={`메뉴 아이템 ${idx}`}
					onClick={() => setTargetYear(item)}
				>
					{item}
				</Menu.Item>
			))}
		</Menu>
	);
	const monthItems = (
		<Menu>
			{Array.from({ length: 12 }).map((item, idx) => (
				<Menu.Item
					key={`메뉴 아이템 ${idx}`}
					onClick={() => setTargetMonth(idx + 1)}
				>
					{idx + 1}
				</Menu.Item>
			))}
		</Menu>
	);
	return (
		<Row align={"middle"} style={{ gap: "1em", marginBottom: "1em" }}>
			<Dropdown
				className={`settle-dropdown`}
				overlay={yearItems}
				placement="bottom"
				arrow={true}
				trigger={["click"]}
			>
				<button className={`settle-dropdown-button`}>
					<p>정산년도</p>
					<div className={`dropdown-target`}>
						<p className={`target-font`}>{targetYear}년</p>
						<img
							src={`/assets/images/products/dropdown-desc.png`}
							alt={`드롭다운`}
							style={{
								height: "1em",
								width: "auto",
							}}
						/>
					</div>
				</button>
			</Dropdown>
			<Dropdown
				className={`settle-dropdown`}
				overlay={monthItems}
				placement="bottom"
				arrow={true}
				trigger={["click"]}
			>
				<button className={`settle-dropdown-button`}>
					<p>정산 월</p>
					<div className={`dropdown-target`}>
						<p className={`target-font`}>{targetMonth}월</p>
						<img
							src={`/assets/images/products/dropdown-desc.png`}
							alt={`드롭다운`}
							style={{
								height: "1em",
								width: "auto",
							}}
						/>
					</div>
				</button>
			</Dropdown>
		</Row>
	);
};
export default SettlementDropdown;
